export const PRODUCTION_ENVIRONMENTS = ['production', 'staging'];
